import * as helpAndLearningAPI from "app/api/helpAndLearningAPI";
import { CmsHelper } from "app/helpers/cmsHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import sanitizeHtml from "sanitize-html";
import HelpAndLearningHeader from "../HelpAndLearningHeader/HelpAndLearningHeader";

type Props = {
  history: any;
  intl: any;
  screenName: string;
  headerMessageId: string;
};

const CmsContentPage: React.FC<Props> = ({
  history,
  intl,
  screenName,
  headerMessageId,
}) => {
  const [html, setHtml] = useState<any>(null);
  const languageId = CmsHelper.getLanguageId(intl.locale);

  useEffect(() => {
    requestContent();
  }, []);

  const requestContent = () => {
    helpAndLearningAPI
      .requestCMSContent(screenName, languageId)
      .then(resp => {
        setHtml(resp.data.contentlets[0].body);
      })
      .catch(error => {
        console.log(error);
        setHtml("No Content returned");
      });
  };

  return (
    <div
      className={`${
        SessionHelper.isAsianSessionView() ? "help-and-learning-asian" : ""
      }`}
    >
      <HelpAndLearningHeader history={history} id={headerMessageId} />
      <div className="help-and-learning__content">
        <div className="help-and-learning__content__info cms-content">
          {html !== null && (
            <div
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(html),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default injectIntl(CmsContentPage);
